import instance from "../config/axios";
import { url, base_apis } from "../config/url";

export const todayLeaderBoard = (data) => {
    return instance.post(`${base_apis?.account}/leaderboard-today`, data).then((res) => {
        return res;
    });
};

export const weeklyLeaderBoard = (data) => {
    return instance.post(`${base_apis?.account}/leaderboard-weekly`, data).then((res) => {
        return res;
    });
};

export const monthlyLeaderBoard = (data) => {
    return instance.post(`${base_apis?.account}/leaderboard-monthly`, data).then((res) => {
        return res;
    });
};

export const allTimeLeaderBoard = (data) => {
    return instance.post(`${base_apis?.account}/leaderboard-allTime`, data).then((res) => {
        return res;
    });
};